import { AnimatedSection } from "./AnimatedSection"
import shareVideo from '../assets/features/soonish_app_preview.mp4'
import mapImage from '../assets/features/map.png'
import viewImage from '../assets/features/view.png'

interface FeatureProps {
  title: string;
  description: string;
  media: {
    type: 'image' | 'video';
    src: string;
    alt?: string;
  };
}

function Feature({ title, description, media }: FeatureProps) {
  return (
    <AnimatedSection className="bg-card p-6 rounded-xl shadow-sm">
      <div className="mb-4 rounded-lg overflow-hidden">
        {media.type === 'video' ? (
          <video 
            className="w-full h-auto rounded-lg"
            autoPlay 
            muted 
            loop 
            playsInline
            controls
          >
            <source src={media.src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img 
            src={media.src} 
            alt={media.alt || title} 
            className="w-full h-auto rounded-lg"
          />
        )}
      </div>
      <h3 className="text-xl font-semibold mb-3 text-primary">{title}</h3>
      <p className="text-muted-foreground">{description}</p>
    </AnimatedSection>
  )
}

export function Features() {
  return (
    <section id="features" className="container mx-auto px-4 py-16">
      <div className="grid md:grid-cols-3 gap-8">
        <Feature 
          title="Save from Anywhere" 
          description="Share links directly from social media and add them to your map instantly."
          media={{
            type: 'video',
            src: shareVideo,
            alt: 'Share extension demonstration'
          }}
        />
        <Feature 
          title="View on Map" 
          description="See all your saved places on an interactive map. Never lose track again."
          media={{
            type: 'image',
            src: mapImage,
            alt: 'Map view screenshot'
          }}
        />
        <Feature 
          title="Keep Notes" 
          description="Add personal notes and details about why you saved each place."
          media={{
            type: 'image',
            src: viewImage,
            alt: 'Notes feature screenshot'
          }}
        />
      </div>
    </section>
  )
} 